import styled from 'styled-components'

export const Container = styled.div`
  background-color: #FFFFFF;
  width: 100%;
  margin-bottom: 10px;
  box-shadow: 0px 2px 10px -6px #252525;
  text-decoration: none;
  border-radius: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  cursor: pointer;

  &:hover {
    background-color: #F7F7F7;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

export const Image = styled.img`
  width: 50px;
  height: 50px;
  border: 1px solid #F0F0F0;
  border-radius: 15px;
  margin-right: 20px;
`

export const InfoText = styled.p`
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #000000;
  margin: 0px;
`
